/// <amd-module name="Artifacts/Maven/helpers/MavenDependencyHelper" />
import * as MavenRes from "Artifacts/Maven/Resources";
import { IDependencyGroup } from "Artifacts/Root/types/IDependency";

export class MavenDependencyHelper {
  public static formatGroupNames(dependencyGroups: IDependencyGroup[]): void {
    for (const dependencyGroup of dependencyGroups) {
      dependencyGroup.group = MavenDependencyHelper._getMavenGroupName(dependencyGroup.group);
    }
  }

  private static _getMavenGroupName(group: string): string {
    if (group === "compile") {
      return MavenRes.MavenDependencies_CompileFriendly;
    } else if (group === "test") {
      return MavenRes.MavenDependencies_TestFriendly;
    } else if (group === "runtime") {
      return MavenRes.MavenDependencies_RuntimeFriendly;
    } else if (group === "system") {
      return MavenRes.MavenDependencies_SystemFriendly;
    } else if (group === "provided") {
      return MavenRes.MavenDependencies_ProvidedFriendly;
    } else if (group === "import") {
      return MavenRes.MavenDependencies_ImportFriendly;
    }

    return group;
  }
}
